export const LIST_DELETE_NO_SELECTION: string=`No row selected.`;
export const LIST_DELETE_SUCCESS: string=`Delete Successful.`;
export const LIST_DELETE_FAIL: string=`Delete error.`;
export const LIST_PDF_EXPORT_FAIL: string=`PDF export error.`;
